import { Controller } from '@hotwired/stimulus'
import { stimulus } from '~/init'

export default class ModalsController extends Controller {
  static targets = ['dialog']

  connect () {
    document.addEventListener('turbo:before-visit', this.#cleanupBeforeNavigation.bind(this))
  }

  disconnect () {
    document.removeEventListener('turbo:before-visit', this.#cleanupBeforeNavigation.bind(this))
    this.openedDialog?.removeEventListener('click', this.#closeOnBackdropClick.bind(this))
    this.openedDialog?.removeEventListener('close', this.#handleClose.bind(this))
    this.openedDialog?.close()
  }

  show (e) {
    document.body.classList.add('body-overflow')
    this.openedDialog = this.#getDialog(e)
    this.openedDialog.addEventListener('click', this.#closeOnBackdropClick.bind(this))
    this.openedDialog.addEventListener('close', this.#handleClose.bind(this))
    this.#getDialog(e)?.showModal()
  }

  close (e) {
    this.#getDialog(e)?.close()
  }

  #getDialog (e) {
    const id = e.currentTarget.dataset.id
    return this.dialogTargets.find(dialog => dialog.id === id)
  }

  #handleClose () {
    document.body.classList.remove('body-overflow')
  }

  #closeOnBackdropClick (e) {
    if (e.target === this.openedDialog) {
      this.openedDialog.close()
    }
  }

  #cleanupBeforeNavigation () {
    document.body.classList.remove('body-overflow')
  }
}

stimulus.register('modals', ModalsController)
